import React from "react";
import "./FrontPage.scss";
import { EventScene } from "../../components/Three/EventScene/EventScene";
import { SceneCanvas } from "../../components/Three/SceneCanvas/SceneCanvas";
import { OverlaySlides } from "./OverlaySlides/OverlaySlides";
import { DrAce } from "../../components/Lottie/DrAce/DrAce";
import { Logo } from "../../components/Logo/Logo";
import { SlideMenu } from "./SlideMenu/SlideMenu";

interface IProps {

}

export function FrontPage(props: IProps) {
    return (
        <div className="front-page-wrapper">
            <SceneCanvas>
                <EventScene />
            </SceneCanvas>
            <OverlaySlides />
            <div className="logo-container">
                <Logo variant={'compact'} />
            </div>
            <SlideMenu />
            <DrAce />
        </div>
    )
}
